import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className='abs-list ftrShape1'>
        </div>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12 address'>
            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/logo.gif" alt="Mata Mariyam Jan Sewa" class="img-fluid footerlogo" />
              <h3>keep In Touch</h3>
             
              <p><i className="bi bi-house-door-fill"></i> <span><Link to="https://maps.app.goo.gl/LDcNQ5wQgEb8HS4v6" target="_blank">Mahendragarh, Haryana - 123001</Link></span></p>
              <p><i className="bi bi-telephone-fill"></i> <span><a href="tel:01282260211">01282-260211</a></span></p>
              <p><i className="bi bi-envelope-fill"></i> <span> <a href="mailto:matamariamjansevavidyalaya@gmail.com">matamariamjansevavidyalaya@gmail.com</a></span></p>

              <ul className='socialMedia'>
                <li>
                  <Link to="/">
                    <LazyLoad>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/facebook.png" alt="Mata Mariyam Jan Sewa" />
                    </LazyLoad>
                  </Link>
                </li>

                <li>
                  <Link to="https://www.youtube.com/watch?v=gr40NebcZw0" target="_blank">
                    <LazyLoad>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/youtube.png" alt="Mata Mariyam Jan Sewa" /></LazyLoad>
                  </Link>
                </li>

                <li>
                  <Link to="/">
                    <LazyLoad>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/instagram.png" alt="Mata Mariyam Jan Sewa" /></LazyLoad>
                  </Link>
                </li>
              </ul>

            </div>

            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12'>
              <h3>Locate Us</h3>
              <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d112645.89199731487!2d76.02086477172406!3d28.07992599200894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3912b63e7c70e30b%3A0xcb148c33156d6b98!2s34H3%2BX8J%2C%20Nasibpur%2C%20Narnaul%2C%20Haryana%20123001!3m2!1d28.0799506!2d76.1032662!5e0!3m2!1sen!2sin!4v1746696686775!5m2!1sen!2sin" width="95%" height="200" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className='col-xl-2 col-lg-6 col-sm-4 col-xs-12'>
              <h3>Quick Links</h3>
              <div className='quick-link'>
                <ul>
                  <li><Link to="/"><i className="bi bi-caret-right-fill"></i>HOME</Link></li>
                  <li><Link to="/about"><i className="bi bi-caret-right-fill"></i>ABOUT</Link></li>
                  <li><Link to="/CBSE-disclosure"><i className="bi bi-caret-right-fill"></i>MANDATORY DISCLOSURE</Link></li>
                  <li><Link to="/syllabus"><i className="bi bi-caret-right-fill"></i>SYLLABUS</Link></li>
                  {/* <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/Book_list.pdf" target='_blank'><i className="bi bi-caret-right-fill"></i>BOOKLIST </Link></li> */}
                  <li><Link to="/Tc"><i className="bi bi-caret-right-fill"></i>TC</Link></li>
                  <li><a href="https://portalguidelines.campuscare.info/index.html#MMJSVN" target="_blank"><i className="bi bi-caret-right-fill"></i>PORTAL HELP</a></li>
                  <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/Terms-Conditions.pdf" target='_blank'><i className="bi bi-caret-right-fill"></i>Terms & Condition </Link></li>
                </ul>
              </div>
            </div>
            <div className='col-xl-4 col-lg-6 col-sm-8 col-xs-12'>
              <div className='d-flex'>
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                </div>
                <LazyLoad>
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/phone-icon.png" className="img-fluid mx-auto d-block" /></LazyLoad>
              </div>
              <div className='mobileapp'>
                <a href="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target="_blank">
                  <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/N-apple.png" className="img-fluid" /></LazyLoad>
                </a>
               
                <a href="https://play.google.com/store/apps/details?id=com.entab.learninglab&amp;hl=en-IN" target="_blank">
                  <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/N-playstore.png" className="img-fluid" /></LazyLoad>
                </a>
                </div>
                <div className='school-code'>
                <a className="link">School Code: MMJSVN</a>
                </div>
              
            </div>
          </div>
        </div>
      </div>
      <div className='copyright'>
        ©️ Copyright 2019-2026 By Mata Mariam Jan Seva Vidyalaya | Accelerating By  <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
